module.exports = __webpack_public_path__ + "static/img/8.9808abc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/eng/8.png
// module id = djRY
// module chunks = 0